import { useCallback } from 'react';
import useNotificationStore from '../store/useNotificationStore';

/**
 * Hook to manage notifications across the app
 * @returns {Object} Notification methods
 */
const useNotification = () => {
  const { showSuccess, showError, showWarning, showInfo, showNotification, clearNotification } =
    useNotificationStore();

  const success = useCallback(
    (message, duration) => {
      showSuccess(message, duration);
    },
    [showSuccess]
  );

  const error = useCallback(
    (message, duration) => {
      showError(message, duration);
    },
    [showError]
  );

  const warning = useCallback(
    (message, duration) => {
      showWarning(message, duration);
    },
    [showWarning]
  );

  const info = useCallback(
    (message, duration) => {
      showInfo(message, duration);
    },
    [showInfo]
  );

  const notify = useCallback(
    (type, message, duration) => {
      showNotification(type, message, duration);
    },
    [showNotification]
  );

  const clear = useCallback(() => {
    clearNotification();
  }, [clearNotification]);

  return {
    success,
    error,
    warning,
    info,
    notify,
    clear,
  };
};

export default useNotification;
